import { Button } from "@cvpartner/design-system";
import * as React from "react";
import { I18n } from "@/shared/util/translations.ts";
import { Form } from "./shared/Form.tsx";
import { LoginButtonWrapper, Wrapper } from "./shared/Modern.tsx";

export const ForceResetPassword: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <Wrapper
      heading={I18n.t("resetting_password.header_title_forced")}
      subheading={I18n.t("resetting_password.header_subtitle_forced").split(
        "\n\n",
      )}
    >
      <Form
        action="/session/password/force_reset"
        onSubmit={() => {
          setIsLoading(true);
        }}
      >
        <LoginButtonWrapper center={isLoading}>
          {isLoading ? (
            <Button
              type="submit"
              hierarchy="primary"
              variant="iconOnly"
              loading={true}
            />
          ) : (
            <Button type="submit" hierarchy="primary">
              {I18n.t("resetting_password.button_send")}
            </Button>
          )}
        </LoginButtonWrapper>
      </Form>
    </Wrapper>
  );
};
